export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/cst/integral/query`,
          data
        });
      },
      list (data){
        return http.json({
            url: 'cst/integral/backList',
            data
        })
     },
      save(data) {
          return http.json({
              url: '/cst/integral/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/cst/integral/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      remove(data) {
          return http.json({
              url: `/cst/integral/delete?id=${data[0].id}`,
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/cstIntegral.js